import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { setTarget } from './familySlice'
import { sendAnalyticsEvents } from '../../analytics/common'
import { EVENTS } from '../../analytics/events'
import { selectEventsData, setEventData } from '../events/eventsSlice'
import ChooseOptionContainer from './ChooseOptionContainer'


const ChooseTarget = ({ history }) => {
    const dispatch = useDispatch();
    const eventsData = useSelector(selectEventsData);
    const BUTTONS = ['wife', 'husband', 'girlfriend', 'boyfriend', 'my_ex'];

    const onContinueClick = (whoTrack) => {
        dispatch(setEventData({ id: 'TrackWho', data: whoTrack }));
        sendAnalyticsEvents(EVENTS.onboardingTrackSubmitted, {
            ...eventsData,
            TrackWho: whoTrack,
        });
        dispatch(setTarget(whoTrack));
        history.push('/create-place')
    };

    return <ChooseOptionContainer title={'who_will_tracked'}
                                  description={'tracking_description'}
                                  pageEvent={'onboardingTrack'}
                                  buttons={BUTTONS}
                                  onContinueClick={onContinueClick}
    />
};

export default ChooseTarget